import { render, staticRenderFns } from "./Report1.vue?vue&type=template&id=06a5c985&scoped=true&"
import script from "./Report1.vue?vue&type=script&lang=js&"
export * from "./Report1.vue?vue&type=script&lang=js&"
import style0 from "./Report1.vue?vue&type=style&index=0&id=06a5c985&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a5c985",
  null
  
)

export default component.exports